<template>
  <UpsellItemBase
    :title="product.name + ' Goggle Lens Protector'"
    :subtitle="product.subTitle"
    :price="product.price"
    :sku="product.sku"
    :selected="upsell.isInCart"
    :upsell="upsell"
    :index="index"
  >
    <template #content>
      <SwatchSelect
        :variants="variants"
        :active-swatch-index="activeSwatchIndex"
        background="transparent"
        display="flex"
        :full-width-swatches="false"
        size="small"
        :class="$b('selector')"
        @active-swatch-index-changed="activeSwatchIndex = $event"
      />
    </template>
  </UpsellItemBase>
</template>

<script>
export default {
  name: 'UpsellItemMultipleSimple',

  props: {
    upsell: { type: Object, default: () => ({}) },
    index: { type: Number, default: 0 }
  },
  data: () => ({
    activeSwatchIndex: 0
  }),
  computed: {
    product () {
      return this.upsell.products[this.activeSwatchIndex]
    },
    variants() {
      return this.upsell.products.map((cp) => ({
        sku: cp.sku,
        legacySKU: cp.sku,
        normalisedSKU: cp.sku,
        options: [],
        frameOption: null,
        lensOption: null,
        swatches: [null, null],
        swatchIcon: cp?.product?.swatchIconOverride?.url,
        price: null,
        isInStock: true,
        isRecycled: false,
        isIrisLens: false,
        isLimitedEdition: true,
        url: null,
      }))
    }
  },
  watch: {
    activeSwatchIndex () {
      // eslint-disable-next-line vue/no-mutating-props
      this.upsell.product = this.product
    }
  }
}
</script>
<style lang="postcss">
.UpsellItemMultipleSimple {
  @apply bg-red;
}

.UpsellItemMultipleSimple__selector {
  @apply mt-2;
}
</style>
